import type { CellContext } from '@tanstack/react-table'

import { HighlightText } from '@/components/ui/table/DataTable/HighlightText'
import type { Transaction } from '@/modules/projects'

export const DescriptionCell = (cell: CellContext<Transaction, string>) => {
  const searchQuery = cell.table.options.meta?.searchQuery

  return (
    <>
      <HighlightText text={cell.getValue()} query={searchQuery} />
      {cell.row.original.internalTransfer ? <InternalTransferBadge /> : null}
    </>
  )
}

// Marks a deposit-sweep transfer between the customer's own buckets. Shown in the ledger but
// excluded from reconcile and the money totals.
const InternalTransferBadge = () => (
  <span
    title="Internal transfer between the customer's own cash buckets; not counted in totals or reconcile"
    className="ml-1.5 inline-flex items-center rounded-full border border-slate-200 bg-slate-50 px-2 py-0.5 align-middle text-xs font-medium text-slate-600"
  >
    Internal
  </span>
)
